import { computed, Injectable, signal } from "@angular/core";
import { MenuItem } from "primeng/api";

@Injectable({
	providedIn: "root",
})
export class NavService {
	private menuItemsSignal = signal<MenuItem[]>([]);

	menuItems = computed(() => this.menuItemsSignal());

	setMenuItems(menuItems: MenuItem[]): void {
		this.menuItemsSignal.set(menuItems);
	}
}
